import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowRight } from 'lucide-react';

const NotFound = () => {
  const funnyPhrases = [
    "Oops! This page is more hidden than an API key in a public repo.",
    "Secret not found. Have you tried looking in the .env file?",
    "Looks like this page got pushed to the wrong branch.",
    "This page is as elusive as a properly secured GitHub repository.",
    "This page is playing hide and seek better than leaked credentials in commit history.",
    "Uh-oh! This page is more lost than a password in plaintext.",
    "Seems like this page doesn't want to be grabbed by gitGraber.",
    "This page is harder to find than an unsecured S3 bucket. Keep looking!",
    "404: Like finding a needle in a haystack of git commits.",
    "This route is more deprecated than Base64 encoded secrets.",
    "Looks like this page got accidentally git-ignored.",
    "This endpoint is more mysterious than undocumented API tokens.",
    "Page not found - just like those missing environment variables.",
    "404: Like that moment when 'git reset --hard HEAD~1' doesn't undo the API key commit.",
    "This page disappeared faster than running 'git filter-branch' in blind panic.",
    "404: This page was probably committed with 'git commit -m \"fix\"' and never documented.",
    "Page not found - must have been removed after someone leaked the database password in a PR comment.",
    "This route is as missing as that AWS_ACCESS_KEY_ID that got pushed to main last week.",
    "404: Like that time someone did 'git add .' without checking for .env files first.",
    "This page vanished faster than a JWT secret after a security audit.",
    "Page not found - probably got deleted when someone realized they committed their Stripe key.",
    "404: This endpoint is more elusive than a properly rotated API token.",
    "Looks like this page got stashed away, just like those credentials that should have been.",
    "This route returned 404 faster than GitGraber detects a leaked private key.",
    "Page not found - must have been removed in the same commit that exposed the MongoDB URI."
  ];

  const randomPhrase = funnyPhrases[Math.floor(Math.random() * funnyPhrases.length)];

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-[500px] text-center">
        {/* Icon */}
        <div className="w-24 h-24 mx-auto mb-8 bg-accent-soft rounded-2xl flex items-center justify-center">
          <img 
            src="/notfound.png" 
            alt="Not Found" 
            className="w-[60px] h-[60px]"
          />
        </div>

        {/* 404 Title */}
        <h1 className="text-display text-ink mb-4">404</h1>
        
        {/* Funny phrase */}
        <p className="text-body text-ink-secondary mb-10 max-w-md mx-auto leading-relaxed">
          {randomPhrase}
        </p>

        {/* Action button */}
        <Link 
          to="/" 
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-ink text-white font-medium rounded-md hover:bg-ink/90 transition-base"
        >
          <Home size={18} />
          <span>Go back to Home</span>
          <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
